import React, { useContext } from 'react';
import {
  Dialog,
  DialogTrigger,
  DialogSurface,
  DialogTitle,
  DialogBody,
  DialogContent,
  DialogActions,
  Button,
  useId,
} from '@fluentui/react-components';
import { I18nContext, I18nModel } from '@bingads-webui/copilot-i18n';
import type { ErrorDialogProps } from './types';

export const ErrorDialog = ({
  open, setOpen,
}: ErrorDialogProps) => {
  const i18n = useContext(I18nContext) as I18nModel;

  const dialogId = useId('dialog-');

  return (
    <Dialog
      open={open}
      onOpenChange={(_e, data) => {
          setOpen(data.open);
        }}
    >
      <DialogSurface
        aria-labelledby={`${dialogId}-title`}
        aria-describedby={`${dialogId}-content`}
      >
        <DialogBody>
          <DialogTitle id={`${dialogId}-title`}>
            {i18n.getString(_TL_('We\'ve encountered an error with chat history.'))}
          </DialogTitle>
          <DialogContent id={`${dialogId}-content`}>
            {i18n.getString(_TL_('We\'re experiencing an issue with chat history. Please try again.'))}
          </DialogContent>
          <DialogActions>
            <DialogTrigger disableButtonEnhancement>
              <Button appearance="primary" onClick={() => setOpen(false)} className="cancel-error-dialog">{i18n.getString(_TL_('Cancel'))}</Button>
            </DialogTrigger>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};
